export const INSIGHTS_IMPORT_QUEUE_DISMISSALS_STORAGE_KEY =
  'insights-import-queue-dismissed-ids';

/** Cap so localStorage cannot grow without bound if clear is used often. */
export const INSIGHTS_IMPORT_QUEUE_DISMISSALS_MAX = 500;
